import { render, staticRenderFns } from "./InquiryDetail.vue?vue&type=template&id=c43e172a&scoped=true"
import script from "./InquiryDetail.vue?vue&type=script&lang=ts"
export * from "./InquiryDetail.vue?vue&type=script&lang=ts"
import style0 from "./InquiryDetail.vue?vue&type=style&index=0&id=c43e172a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c43e172a",
  null
  
)

export default component.exports